import { useCallback, useEffect, useMemo, useState } from 'react'
import { getLandingPageCodes } from '../utils/helpers/supabase.helpers'
import { LandingPageCode } from '../types/supabase'
import { logger } from '../utils/helpers/logger'

interface UseUserLandingPagesReturn {
  landingPages: LandingPageCode[]
  defaultLandingPage: LandingPageCode | null
  isLoading: boolean
  refetch: () => Promise<void>
}

export const useUserLandingPages = (): UseUserLandingPagesReturn => {
  const [landingPages, setLandingPages] = useState<LandingPageCode[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const fetch = useCallback(async () => {
    setIsLoading(true)
    const { data, error } = await getLandingPageCodes()
    if (error) {
      logger.error(error, 'FetchUserLandingPages')
    }
    setLandingPages(data ?? [])
    setIsLoading(false)
  }, [])

  useEffect(() => {
    fetch()
  }, [fetch])

  const defaultLandingPage = useMemo(() => landingPages.find((lp) => lp.is_default) ?? null, [landingPages])

  return { landingPages, defaultLandingPage, isLoading, refetch: fetch }
}
